import { render, staticRenderFns } from "./PageLocations.vue?vue&type=template&id=006e3114&"
import script from "./PageLocations.vue?vue&type=script&lang=js&"
export * from "./PageLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006e3114')) {
      api.createRecord('006e3114', component.options)
    } else {
      api.reload('006e3114', component.options)
    }
    module.hot.accept("./PageLocations.vue?vue&type=template&id=006e3114&", function () {
      api.rerender('006e3114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageLocations.vue"
export default component.exports